'use strict';

export default class XeroController {
  /*@ngInject*/
  constructor($http, $scope, $window, Modal, JSONToCSVConvertor) {
    this.$http = $http;
    this.$window = $window;
    this.Modal = Modal;
    this.JSONToCSVConvertor = JSONToCSVConvertor;
  }

  $onInit() {
    this.$http.get('/api/xero/session')
      .then(response => {
        this.session = response.data;
      });
  }

  connectXero() {
    this.connecting = true;
    this.$http.get('/api/xero')
      .then(response => {
        if (response.data.consentUrl) {
          this.$window.location.href = response.data.consentUrl;
        } else {
          this.connecting = false;
          this.session = this.session || {};
          this.session.error = response.data.error || 'Failed to get consent URL';
        }
      })
      .catch(err => {
        this.connecting = false;
        this.session = this.session || {};
        this.session.error = err.data ? err.data.error : 'Failed to connect to Xero';
      });
  }

  refreshToken() {
    this.$http.get('/api/xero/refresh-token')
      .then(response => {
        this.session = response.data;
      });
  }


}



// WEBPACK FOOTER //
// ./client/app/admin/xero/xero.controller.js